import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

export default function Footer() {
  const { t, lang } = useI18n();
  const base = `/${lang}`;

  return (
    <footer className="bg-[#0F2447] text-[#c9d3e4] mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-md bg-[#B85D3D] text-white font-serif text-lg font-semibold">X</span>
            <div className="text-white font-serif text-xl">{t("header.brand")}</div>
          </div>
          <p className="text-sm leading-relaxed text-[#a8b6cf] max-w-md">{t("footer.about_body")}</p>

          <h4 className="mt-8 text-white font-serif text-base mb-2">{t("footer.legal_title")}</h4>
          <ul className="text-xs leading-relaxed space-y-1 text-[#a8b6cf]">
            <li>{t("footer.legal.company")}</li>
            <li>{t("footer.legal.cuit")}</li>
            <li>{t("footer.legal.igj")}</li>
            <li>{t("footer.legal.aaip")}</li>
            <li>{t("footer.legal.activity")}</li>
            <li>{t("footer.legal.address")}</li>
            <li>{t("footer.legal.jurisdiction")}</li>
            <li>{t("footer.legal.founded")}</li>
          </ul>
          <p className="mt-4 text-[11px] text-[#8695b0] leading-relaxed max-w-md">{t("footer.legal.cnv_note")}</p>
        </div>

        <div>
          <h4 className="text-white font-serif text-base mb-3">{t("footer.sitemap_title")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to={base} className="hover:text-white" data-testid="footer-link-home">{t("footer.links.home")}</Link></li>
            <li><a href={`${base}#sectors`} className="hover:text-white" data-testid="footer-link-sectors">{t("footer.links.sectors")}</a></li>
            <li><a href={`${base}#how`} className="hover:text-white" data-testid="footer-link-how">{t("footer.links.how_it_works")}</a></li>
            <li><a href={`${base}#transparency`} className="hover:text-white" data-testid="footer-link-transparency">{t("footer.links.transparency")}</a></li>
            <li className="pt-2 border-t border-[#26436e]"></li>
            <li><Link to={`${base}/privacy`} className="hover:text-white" data-testid="footer-link-privacy">{t("footer.links.privacy")}</Link></li>
            <li><Link to={`${base}/cookies`} className="hover:text-white" data-testid="footer-link-cookies">{t("footer.links.cookies")}</Link></li>
            <li><Link to={`${base}/terms`} className="hover:text-white" data-testid="footer-link-terms">{t("footer.links.terms")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-serif text-base mb-3">{t("footer.contact_title")}</h4>
          <ul className="space-y-2 text-sm">
            <li><span className="text-[#8695b0]">{t("footer.contact.email_label")}</span> <a href={`mailto:${t("footer.contact.email")}`} className="hover:text-white">{t("footer.contact.email")}</a></li>
            <li><span className="text-[#8695b0]">{t("footer.contact.press_label")}</span> <a href={`mailto:${t("footer.contact.press")}`} className="hover:text-white">{t("footer.contact.press")}</a></li>
            <li><span className="text-[#8695b0]">{t("footer.contact.hours_label")}</span> {t("footer.contact.hours")}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#26436e]">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-xs text-[#8695b0]">
          <div>{t("footer.copyright")}</div>
          <div className="max-w-2xl md:text-right">{t("footer.disclaimer")}</div>
        </div>
      </div>
    </footer>
  );
}
